module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solicitud"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.isEditing) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Modificando la solicitud " + _vm._s(_vm.solicitud.id))]) : (_vm.isExcepcion) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Ingresa una solicitud de permisos sin validaciones")]) : _c('span', [_vm._v("Ingresa una solicitud de permisos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [(_vm.mostrarIndicaciones && !_vm.isExcepcion) ? _c('div', {
    key: "indicaciones",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        _vm.mostrarIndicaciones = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud la debe aprobar ")]), _c('strong', [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_vm._v(_vm._s(_vm.jefe))])])])])]) : _vm._e(), _c('div', {
    key: "transaccion",
    staticClass: "contenedor-transaccion"
  }, [(_vm.isExcepcion) ? _c('div', {
    staticClass: "contenedor-input-relative"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('strong', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "datos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleado),
      expression: "codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), (_vm.nombreEmpleado) ? _c('div', {
    staticClass: "descripcion"
  }, [_c('p', [_vm._v(_vm._s(_vm.nombreEmpleado))])]) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "contenedor-input-relative"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('strong', [_vm._v("Tipo de permiso")]), _c('div', {
    staticClass: "datos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tipo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipo = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaTipo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), (_vm.descripcionTipo) ? _c('div', {
    staticClass: "descripcion"
  }, [_c('p', [_vm._v(_vm._s(_vm.descripcionTipo))])]) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaTipo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-tipos-permiso', {
    attrs: {
      "codigo": _vm.tipo
    },
    on: {
      "selected": _vm.seleccionarTipo,
      "close": function($event) {
        _vm.mostrarBusquedaTipo = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('br'), _c('div', {
    staticClass: "motivo"
  }, [_c('div', [_c('strong', [_vm._v("Motivo")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivo),
      expression: "motivo"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.motivo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivo = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "title-detalle"
  }, [_c('strong', [_vm._v("Ingrese las fechas y horas que se ausentará")])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, _vm._l((_vm.detalle), function(o, index) {
    return _c('div', {
      key: 'fechas_horas_permisos_' + index,
      staticClass: "detalle"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Desde")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Desde")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.desde),
        expression: "o.desde"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
      },
      domProps: {
        "value": (o.desde)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "desde", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Hasta")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Hasta")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.hasta),
        expression: "o.hasta"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
      },
      domProps: {
        "value": (o.hasta)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "hasta", $event.target.value)
        }
      }
    })])]), _c('div', {
      staticClass: "flex jcc"
    }, [_c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Hora desde")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Hora desde")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.horaDesde),
        expression: "o.horaDesde"
      }],
      staticClass: "input",
      attrs: {
        "type": "time",
        "min": "8:00",
        "max": "18:30"
      },
      domProps: {
        "value": (o.horaDesde)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "horaDesde", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Hora hasta")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Hora hasta")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.horaHasta),
        expression: "o.horaHasta"
      }],
      staticClass: "input",
      attrs: {
        "type": "time",
        "min": "8:00",
        "max": "18:30"
      },
      domProps: {
        "value": (o.horaHasta)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "horaHasta", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "delete-detalle"
    }, [_c('span', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.eliminarDetalle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0), _c('div', {
    staticClass: "agregar-linea"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.agregarDetalleVacio
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Agregar linea")])])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('span', [_vm._v("Guardar")])]), (!_vm.isExcepcion) ? _c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _c('span', [_vm._v("Guardar y Enviar")])]) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1d74e6c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Permisos_Solicitud.vue
// module id = 952
// module chunks = 0